import { useShowResponseStatus } from '@/shared';

import { useGetWithdrawalMethodsQuery } from '../store/withdrawal-methods-api';

export const useGetWithdrawalMethods = () => {
  const { data, isLoading, isError } = useGetWithdrawalMethodsQuery();

  useShowResponseStatus({
    isError,
  });

  return {
    data,
    isLoading,
  };
};
